import { render, staticRenderFns } from "./AuditFlowTable.vue?vue&type=template&id=66731296&"
import script from "./AuditFlowTable.vue?vue&type=script&lang=js&"
export * from "./AuditFlowTable.vue?vue&type=script&lang=js&"
import style0 from "./AuditFlowTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports